









# import settings from '@/settings'

export default {
    name: 'company_telework'

}
